import ApiClient from '../../api/ApiClient';

// actions
const actions = {
  create: async (_, withdrawData) => {
    try {
      const api = new ApiClient('withdraw_issues', { accountScoped: true });
      const response = await api.create(withdrawData);
      return response.data;
    } catch (error) {
      // 返回错误对象而不是抛出异常，这样组件可以处理错误
      return {
        error: error.response?.data?.error || error.message || 'An unknown error occurred',
      };
    }
  },
};

export default {
  namespaced: true,
  actions,
}; 